import { useOrganizationContext } from 'src/sections/@dashboard/organization/hooks/useOrganizationContext';
import OrganizationDetailsOrganizationScheduleTabsPage from './OrganizationDetailsOrganizationScheduleTabsPage';
import OrganizationDetailsProfessionalScheduleTabsPage from './OrganizationDetailsProfessionalScheduleTabsPage';

export default function OrganizationDetailsScheduleTabsPage() {
  const { isProfessionalRoleSelected } = useOrganizationContext();

  return isProfessionalRoleSelected ? (
    <OrganizationDetailsProfessionalScheduleTabsPage />
  ) : (
    <OrganizationDetailsOrganizationScheduleTabsPage />
  );
}
